import { observable, action } from 'mobx'
import http from 'src/helper/http'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {
      avatarurl: '',
      nationalAnthem: '' // 国歌
    },
    activityTime: {
      beginTime: 0,
      endTime: 0,
      remaintime: 0 // 活动剩余时间
    },
    activityKey: 'nationalStar',
    countryList: [],
    countryMine: {},
    gifts: [],
    rankingList: [],
    rankingMine: {},
    rankTop3: [], // 榜单前三
    rewardInfo: {},
    activeGiftId: '',
    rewardlist: [] // 奖励列表
  }

  @action async setUid(uid) {
    this.data.uid = uid
  }

  // 活动上个周期排行榜前3
  @action async getRankTop3() {
    const data = await http.post(
      '/web/activity/rankTop3',
      {
        activityKey: 'nationalStar',
        rewardType: 'country'
      }
    )

    if (data.code === 0 && data.res) {
      this.data.rankTop3 = data.res
    }
  }

  // 活动当前周期排行榜
  @action async getRanking(rewardType = 'country') {
    let data = await http.post(
      '/web/activity/ranklist',
      {
        activityKey: 'nationalStar',
        rewardType // 本国助威榜传 nationalUser
      }
    )

    if (data.code === 0 && data.res) {
      const { list, mine } = data.res
      if (rewardType === 'country') {
        this.data.countryList = list
        this.data.countryMine = mine
      } else {
        this.data.rankingList = list
        this.data.rankingMine = mine
      }
    }
  }

  // 获取国家信息
  @action async getMyAccountInfo() {
    const data = await http.post('/web/MyAccountInfo')
    const { code, res } = data
    if (code === 0 && res) {
      this.data.userInfo = data.res
    }
  }

  // 获取活动时间信息
  @action async getActivityTimeinfo() {
    const data = await http.post('/web/activity/timeinfo', {
      activityKey: 'nationalStar'
    })

    if (data.code === 0 && data.res) {
      const { beginTime, endTime, countdown } = data.res
      this.data.activityTime = {
        beginTime,
        endTime,
        remaintime: countdown
      }
    }
  }

  // 获取活动礼物信息
  @action async getGiftInfo() {
    const data = await http.post('/web/activity/giftinfo', {
      activityKey: 'nationalStar',
      rewardType: 'country'
    })

    const { code, res } = data

    if (code === 0 && res) {
      this.data.gifts = res
      this.data.activeGiftId = res[0].giftid
    }
  }
}



// WEBPACK FOOTER //
// src/store/activity/national-star.js